import LegalPage from "@/components/shared/LegalPage";

export default function EarningsDisclaimerPage() {
  return (
    <LegalPage
      pageTestId="wc-earnings-disclaimer"
      documentTitle="Earnings Disclaimer"
      title="Earnings Disclaimer"
      lastUpdated="July 2026"
      intro={[
        "WinCampaign provides marketing systems, software, education, and Done-for-You marketing services designed to help business owners increase visibility, generate leads, and grow their businesses.",
        "We make no guarantees regarding income or financial results.",
      ]}
      sections={[
        {
          heading: "No Earnings Guarantees",
          paragraphs: ["Any references made to:"],
          bullets: [
            "$10K/month recurring income",
            "Revenue",
            "Business growth",
            "Financial freedom",
            "Leads",
            "Subscribers",
            "Customers",
            "Sales",
            "Success stories",
          ],
        },
        {
          paragraphs: [
            "are examples of potential business goals and are provided for educational and illustrative purposes only.",
            "They should never be interpreted as guarantees of future results.",
          ],
        },
        {
          heading: "Individual Results Vary",
          paragraphs: ["Business results depend upon numerous factors including:"],
          bullets: [
            "Your effort",
            "Consistency",
            "Sales ability",
            "Marketing execution",
            "Follow-up",
            "Products or services",
            "Industry",
            "Pricing",
            "Competition",
            "Market conditions",
          ],
        },
        {
          paragraphs: [
            "Because these factors vary, no guarantee of results is made.",
          ],
        },
        {
          heading: "Testimonials",
          paragraphs: [
            "Testimonials, client stories, screenshots, and examples reflect individual experiences.",
            "They are not intended to represent typical results.",
          ],
        },
        {
          heading: "Our Services",
          paragraphs: [
            "WinCampaign provides marketing support.",
            "We do not guarantee:",
          ],
          bullets: [
            "Income",
            "Leads",
            "Customers",
            "Subscribers",
            "Revenue",
            "Profits",
            "Business Success",
          ],
        },
        {
          heading: "Your Responsibility",
          paragraphs: ["You are solely responsible for:"],
          bullets: [
            "Running your business",
            "Following up with leads",
            "Closing sales",
            "Serving your customers",
            "Implementing marketing strategies",
            "Managing your business decisions",
          ],
        },
        {
          heading: "No Professional Advice",
          paragraphs: [
            "Nothing on this website should be interpreted as legal, accounting, financial, or tax advice.",
            "Please consult qualified professionals regarding your specific situation.",
          ],
        },
        {
          heading: "Acceptance",
          paragraphs: [
            "By using our website or purchasing our services, you acknowledge that:",
          ],
          bullets: [
            "No earnings guarantees have been made.",
            "Individual results vary.",
            "You accept full responsibility for your business outcomes.",
            "WinCampaign is not liable for your financial performance.",
          ],
        },
        {
          heading: "Contact",
          paragraphs: ["support@wincampaign.io"],
        },
      ]}
    />
  );
}
